<template>
  <v-container class="home pa-5" fluid>
    <v-row class="mb-5">
      <router-link
        v-for="(item, index) in menus"
        :key="index + 'menu-option'"
        :to="item.path"
        class="home_btn ml-5"
      >
        <v-btn class="home_btn_container mb-3" block color="primary" large>
          <v-icon class="mr-2" color="white" large>{{ item.icon }}</v-icon>
          {{ $t(item.title) }}
        </v-btn>
      </router-link>
    </v-row>
    <!--    <v-row class="mb-5">
      <router-link
        v-for="(item, index) in stoconMenus"
        :key="index + 'menu-option'"
        :to="item.path"
        class="home_btn ml-5"
      >
        <v-btn class="home_btn_container" block color="orange darken-1" large>
          <v-icon class="mr-2" color="white" large>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </router-link>
    </v-row>-->
  </v-container>
</template>

<script>
import { MENU_HOME } from "@/common/auth.const";
import { SET_LOADING, SET_PAGE_HEADER } from "@/store/mutations.type";
import jwtService from "@/common/jwt.service";

export default {
  name: "Home",
  data: () => ({
    menus: MENU_HOME.filter((item) =>
      item.authorities.includes(jwtService.getRole()),
    ),
  }),
  methods: {},
  created() {
    this.$store.commit(SET_PAGE_HEADER, []);
    this.$store.commit(SET_LOADING, [true, true]);
    this.$store.commit(SET_LOADING, [false, true]);
  },
};
</script>
<style lang="scss" scoped>
.home {
  &_btn {
    width: 300px;
    &_container {
      height: 70px !important;
    }
  }
}

.home_btn {
  text-decoration: none;
}
.home_btn_container {
  color: white;
}

@media only screen and (max-width: 1360px) {
  .home_btn_container {
    margin-top: 20px;
    color: white;
  }
}
</style>
